<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData" :pagination="false" :loading="tloading" rowKey="id" @change="handleTableChange">
            <template slot="operation" slot-scope="text, record">
                <router-link class="tableLink" :to="{path:'detail_user',query: {id: record.id,}}">详情</router-link>
                <router-link class="tableLink" :to="{path:'edit_user',query: {id: record.id,}}">编辑</router-link>
                <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                    <a class="tableLink" href="javascript:;">删除</a>
                </a-popconfirm>
            </template>
            <template slot="platformType" slot-scope="text">
                <span>
                    {{ platformtypeList.filter( item => { return item.platformtype == text } )[0].platformtypename }}
                </span>
            </template>

        </a-table>

        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

    </div>
</template>
<script>
let pagination = {
    page: 1,
    pageSize: 10,
    total: 0,
}

const columns = [
    {
        title: '用户ID',
        dataIndex: 'userid',
        width: 100,
    },
    {
        title: '平台类型',
        dataIndex: 'platformtype',
        scopedSlots: { customRender: 'platformType' },
        width: 100,
    },
    {
        title: '用户名称',
        dataIndex: 'fullname',
        width: 100,
    },
    {
        title: '业务编码',
        dataIndex: 'platformcode',
        width: 100,
    },
    {
        title: '用户标签',
        dataIndex: 'tags',
        width: 100,
    },
    {
        title: '手机号',
        dataIndex: 'phone',
        width: 100,
    },
    {
        title: '邮件',
        dataIndex: 'email',
        width: 100,
    },

    // {
    //     title: "创建时间",
    //     dataIndex: "createtime",
    //     width:200
    // },
    // {
    //     title: "更新时间",
    //     dataIndex: "updatetime",
    //     width:150
    // },
    // {
    //     title: "更新人",
    //     dataIndex: "updatetuser",
    //     width:150
    // },
    // {
    //     title: "创建人",
    //     dataIndex: "createuser",
    //     width:150
    // },

    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 150,
        scopedSlots: { customRender: 'operation' },
    },
]

import { mapState } from 'vuex'

export default {
    data() {
        return {
            columns,
            tableData: [],
            tloading: false,
            pagination,
            clientWidth: 800,
            ordercoloum: 'total',
            orderstr: 'desc',
            searchP: {},
        }
    },
    methods: {
        handleTableChange(d, v, sorter) {
            if (sorter.order) {
                this.ordercoloum = sorter.field
                this.orderstr = sorter.order.replace('end', '')
            } else {
                this.ordercoloum = ''
                this.orderstr = ''
            }

            this.getAppSumData()
        },
        handlePageChange(v) {
            this.pagination.page = v
            this.getAppSumData()
        },
        handleDelete(item) {
            let that = this
            that.$store
                .dispatch({
                    type: 'mcmsmanager/deletetargetgroup',
                    params: { id: item.id },
                })
                .then((res) => {
                    if (res.status == '200') {
                        that.pagination.page = 1
                        that.getAppSumData()
                    }
                })
        },
        getAppSumData() {
            let that = this
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams: false,
            }
            that.$store
                .dispatch({
                    type: 'mcmsmanager/querytargetgroupspage',
                    params: params,
                })
                .then((res) => {
                    if (res.status == 200 && res.data.success == '1') {
                        let result = res.data.data
                        this.tableData = result.list
                        this.pagination.total = parseInt(result.totalRecords)
                        this.pagination.pageSize = parseInt(result.pageSize)
                        this.pagination.page = parseInt(result.page)
                    }
                    that.tloading = false
                })
                .catch(() => {
                    that.tloading = false
                })
        },
        handleSearch(searchP) {
            this.searchP = searchP
            this.pagination.page = 1
            this.getAppSumData()
        },
    },
    computed: {
        ...mapState('mcmsmanager', {
            platformtypeList: (state) => state.platformtypeList,
        }),
    },
    components: {},
    mounted() {},
}
</script>
<style scoped>
.trend_pagination {
    margin-top: 10px;
}

.tableLink {
    margin-right: 10px;
}
</style>

